import React, {useRef} from "react";
import SignatureCanvas from "react-signature-canvas";
import {TextField, Typography} from "@mui/material";
import {North as AboveIcon,} from "@mui/icons-material";
import {SelectField} from "@atttomyx/react-components";
import {forms, objects, strings} from "@atttomyx/shared-utils";
import {colors} from "@atttomyx/shared-constants";
import {
    ANSWER_TYPE_BOOLEAN,
    ANSWER_TYPE_DATE,
    ANSWER_TYPE_DOUBLE,
    ANSWER_TYPE_INTEGER,
    ANSWER_TYPE_MULTILINE,
    ANSWER_TYPE_SIGNATURE,
    YES_NO
} from "../../constants";
import "./submissionForm.css";

const isValidNumber = (num, metadata) => {
    const nullSafe = objects.defaultIfNullOrUndefined(metadata, {});
    const min = nullSafe.min ? parseFloat(nullSafe.min) : undefined;
    const max = nullSafe.max ? parseFloat(nullSafe.max) : undefined;
    const sanitized = objects.notNullOrUndefined(num) ? parseFloat(num) : undefined;

    return strings.isBlank(num) ||
        (objects.notNullOrUndefined(sanitized)
            && (objects.nullOrUndefined(min) || sanitized >= min)
            && (objects.nullOrUndefined(max) || sanitized <= max));
};

const SubmissionForm = (props) => {
    const { data, questions, onChange : onSync } = props;
    const canvas = useRef(null);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;

        let atLeastOne = false;
        questions.forEach(question => {
            atLeastOne = atLeastOne || strings.isNotBlank(modified[question.id]);
        });

        let valid = atLeastOne;
        questions.forEach(question => {
            const answer = modified[question.id];

            if (valid) {
                valid = (question.type !== ANSWER_TYPE_INTEGER && question.type !== ANSWER_TYPE_DOUBLE)
                    || isValidNumber(answer, question.metadata);
            }
        });

        modified.valid = valid;

        onSync(modified);
    };

    const onStrokeEnd = (field) => {
        if (canvas.current && !canvas.current.isEmpty()) {
            onChange(field, canvas.current.toDataURL());
        }
    };

    return <div className="submission-form">
        {questions.map(question => <div key={question.id} className="field">
            {question.type === ANSWER_TYPE_BOOLEAN ?
                <SelectField
                    label={question.ask}
                    title={question.ask}
                    value={forms.sanitizeValue(data[question.id])}
                    onChange={(value) => onChange(question.id, value)}
                    options={YES_NO}
                /> : question.type === ANSWER_TYPE_DATE ?
                <TextField
                    label={question.ask}
                    title={question.ask}
                    type="date"
                    value={forms.sanitizeValue(data[question.id])}
                    onChange={(event) => onChange(question.id, event.target.value)}
                /> : question.type === ANSWER_TYPE_INTEGER || question.type === ANSWER_TYPE_DOUBLE ?
                <TextField
                    label={question.ask}
                    title={question.ask}
                    type="number"
                    value={forms.sanitizeValue(data[question.id])}
                    onChange={(event) => onChange(question.id, event.target.value)}
                    inputProps={{
                        step: question.type === ANSWER_TYPE_INTEGER ? 1 : undefined,
                        min: question.metadata ? question.metadata.min : undefined,
                        max: question.metadata ? question.metadata.max : undefined,
                    }}
                    error={!isValidNumber(data[question.id], question.metadata)}
                /> : question.type === ANSWER_TYPE_SIGNATURE ?
                <>
                    <SignatureCanvas
                        ref={canvas}
                        canvasProps={{width: 350, height: 100, className: "signature"}}
                        onEnd={() => onStrokeEnd(question.id)}
                        penColor={colors.BLACK}
                    />
                    <div>
                        <Typography variant="caption">
                            Please draw your signature
                        </Typography>
                        <AboveIcon className="above"/>
                    </div>
                </> :
                <TextField
                    multiline={question.type === ANSWER_TYPE_MULTILINE}
                    minRows={question.type === ANSWER_TYPE_MULTILINE ? 2 : undefined}
                    label={question.ask}
                    title={question.ask}
                    type="text"
                    value={forms.sanitizeValue(data[question.id])}
                    onChange={(event) => onChange(question.id, event.target.value)}
                />}
        </div>)}
    </div>
}

export default SubmissionForm;
